<template>
  <div class="home">
    <!-- 顶部bar -->
    <!-- <navbar :navtitle="navtitle"></navbar> -->
    <!-- 首页banner -->
    <!-- <div class="swiper-slide"><img :src="homebanner" alt=""></div> -->
    <swiper class="bannerBox">
      <div class="swiper-slide"><img :src="homebanner" alt=""></div>
    </swiper>
    <!-- 订阅区域 -->
    <div class="title-con">
      <div class="title">
        <div class="gls-class">高建华职场教学</div>
        <!-- <div class="up-time">2018-07-01更新</div> -->
      </div>
      <router-link tag="div" class="btn-buy" to="/payment" v-if="buyNow">立即订阅</router-link>
    </div>
    <!-- 下部内容区 -->
    <mt-navbar v-model="selected">
      <mt-tab-item id="1">课程(<span>{{voiceList.length}}</span>)</mt-tab-item>
      <mt-tab-item id="2">简介</mt-tab-item>
    </mt-navbar>

    <!-- tab-container -->
    <mt-tab-container v-model="selected">
      <!-- 内容列表区 -->
      <mt-tab-container-item id="1">
        <ul>
          <li @click="gotoNextPage(index)" v-for="(item,index) in voiceList" :key="item.id">
            <span>{{(index+1)+"&nbsp;&nbsp;"+item.title}}</span>
            <span class="iconfont icon-youjiantou rightArr"></span>
          </li>
        </ul>
        <!-- <mt-cell @click="gotoNextPage" is-link v-for="(item,index) in voiceList" :title="index+item.title" :key="index">
          <span style="color: green">36:44</span>
        </mt-cell> -->
      </mt-tab-container-item>
      <!-- 内容简介区 -->
      <mt-tab-container-item id="2">
        <div class="descimg"></div>
        <!-- <img src="http://121.199.15.7:8080/sp/video/img/1528253187822.jpg" alt="w我是课程介绍"> -->
        <!-- <img src="/static/imgs/desc.jpg" alt=""> -->
      </mt-tab-container-item>
    </mt-tab-container>
    <tabbar></tabbar>
    <mytoast :toastCon="toastCon" :showToast = "showToast"></mytoast>
    <!-- <div class="toast-wrap" v-if="showToast">
      <div class="toast">
        {{ toastCon }}
      </div>
    </div> -->
  </div>
</template>

<script>
import mytoast from '@/basecomponents/Lesin-toast'
import navbar from '@/basecomponents/navbar'
import swiper from '@/basecomponents/swiper'
import tabbar from '@/basecomponents/foot-tab'
export default {
  name: 'home',
  components: {
    navbar,
    swiper,
    tabbar,
    mytoast
  },
  data () {
    return {
      userId:'',
      navtitle:'',
      homebanner:require('../../assets/testImg/gls_cover.jpg'),
      selected:'1', //mint-ui navbar必须
      voiceList:[],
      voiceID:0,
      buyNow: true,
      loginPhoneNum:0,
      isLogin: 0,
      // isBuy: 0,  //是否订购 未订购0 订购1
      // hasOrder: 0, //接口请求是否购买
      nextPage:'mine',
      showToast: 0,
      toastCon: '',
      indexArr:[],
      
    
    }
  },
  created(){
    // 内嵌app进入url
    var _this = this;
    var preURL = window.location.href;
    // console.log(preURL);
    var access_token = this.getQueryValue("access_token");
    // console.log(access_token);
    if(access_token){
      _this.$ajax.get('http://114.55.87.60:8187/rest/byt/validateToken?access_token='+access_token)
      .then(
        (response)=>{
          // console.log(response);
          _this.userId = response.data.userId;
          localStorage.setItem('payPhoneNum',_this.userId);
          localStorage.setItem('loginPhoneNum',_this.userId);
          //是否显示立即订阅按钮
          _this.buyNow = localStorage.getItem('payPhoneNum') != null ? false :true;
        }
      )
    }
    // 活动页进入url
    if(preURL.match(/phone=(\d{11})/)){
      var num = preURL.match(/phone=(\d{11})/)[1];
      localStorage.setItem('payPhoneNum',num);
      localStorage.setItem('loginPhoneNum',num);
    }

    // if(preURL){
    //   num = localStorage.getItem('payPhoneNum') || preURL.match(/phone=(\d{11})/)[1];
    
      // console.log(num);
      // console.log(preURL);
      // console.log(localStorage.getItem('payPhoneNum'));
    // }
  },
  mounted(){
    this.getHomeData();
    // this.isBuy = this.$store.state.isBuy;
    // this.isLogin = this.$store.state.isLogin;
    this.loginPhoneNum = localStorage.getItem('loginPhoneNum');
    //是否显示立即订阅按钮
    this.buyNow = localStorage.getItem('payPhoneNum') != null ? false :true;

    // console.log(localStorage.getItem('payPhoneNum') != null ? false :true);
    // this.hasOrder =  this.$store.state.hasOrder;
  },
  methods: {
    gotoNextPage(index){
      var _this = this;
      if(_this.loginPhoneNum == null){
          // console.log(_this.loginPhoneNum)
          _this.showToast = 1;
          _this.toastCon = "您还没有登录哦";
          setTimeout(function(){
            _this.showToast = 0;
            _this.$router.push('mine');
          },1000)

          return;
      }
      _this.$ajax.get('http://114.55.87.60:8187/rest/video/role/'+localStorage.getItem("payPhoneNum"))
      .then(function (response) {
        // console.log(response);
        if(response.data === true){
          // _this.$store.state.hasOrder = 1;
          // _this.hasOrder = 1;
          _this.$router.push({name: 'Voice',query :{id:index}});         
        }else{
          _this.showToast = 1;
          _this.toastCon = "您还没有订阅哦";
          setTimeout(function(){
            _this.showToast = 0;
            _this.$router.push('payment');
          },1000)
        }
      })
      .catch(function (error) {
        
          console.log(error);
          
      });

      // var _this = this;
      // if(_this.hasOrder !== 1){
      //   _this.showToast = 1;
      //   _this.toastCon = "您还没有订阅哦";
      //   setTimeout(function(){
      //     _this.showToast = 0;
      //     _this.$router.push('payment');
      //   },3000)
      // }else{
      //    _this.$router.push({name: 'Voice',query :{id:index}});
      // }
      
    },
    // 请求首页数据
    getHomeData(){
      var _this = this;
      _this.$ajax.get('http://114.55.87.60:8187/rest/video/getAllVideos')
      .then(
        (homeData)=>{
          // console.log(homeData);
          _this.voiceList = homeData.data;
          // console.log(homeData.data.length)
          var indexArr = [];
          let voiceItems = homeData.data;
          for(let i=0;i<=voiceItems.length; i++){
            // console.log(voiceItems[i]);
            for(var key in voiceItems[i]){
                if(key == "id"){
                  // console.log(key+": "+voiceItems[i][key]);
                  indexArr.push(voiceItems[i][key]);
                  
                }
            }
          }
          _this.indexArr = indexArr;
          _this.$store.state.indexArr = indexArr;
          // console.log(_this.$store.state.indexArr);
        }
      )
    },
    getQueryValue (key){
        var reg = new RegExp("(^|&)" + key + "=([^&]*)(&|$)", "i");
        var r = window.location.search.substr(1).match(reg);
        if (r != null){
            return (r[2]);
        }
        return null;
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.home{
  height: 100vh;
  overflow: hidden;
  .navbar{
    .backbtn{
      span{

        color: #fff;
      }
    }
    /deep/ .title-home{
      display: none;
    }
  }
  // .swiper{
  //   // margin-top: 80px;
  // }
  .swiper-slide{
    height: 350px;
      width: 100%;
      background-image: url('~assets/testImg/gls_cover.jpg');
      background-size: cover;
      img{
          width: 100%;
          height: 350px;
      }
  }
  .title-con{
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 30px;
    height: 120px;
    background-color: #fff;
    .title{
      .gls-class{
        font-size: 32px;
      }
      .up-time{
        margin-top: 10px;
        font-size: 24px;
        color: #999999;
      }
    }
    .btn-buy{
      font-size: 30px;
      color: #fff;
      width: 164px;
      height: 60px;
      line-height: 65px;
      text-align: center;
      border-radius: 10px;
      background-color: #28aaff;
    }
  }
  /deep/ .mint-navbar{
    margin-top: 15px;
    margin-bottom: 1px;
    height: 80px;
    .mint-tab-item{
      font-size: 30px;
      .mint-tab-item-label{
        height: 80px;
        font-size: 30px;
        line-height: 50px;
        color: #222;
      }
    }
    .mint-tab-item.is-selected{
      border-bottom: 6px solid #28aaff;
      color: #28aaff;
      margin-bottom: -4px;
      content: "viewport-units-buggyfill; border-bottom: 0.4vw solid #28aaff; margin-bottom: -0.4vw";
      .mint-tab-item-label{
        height: 80px;
        font-size: 30px;
        line-height: 50px;
        color: #28aaff;
      }
    }
  }
  /deep/ .mint-tab-container{
    height: 1500px;
    // padding-bottom: 20vh;
    margin-bottom: 100px;
    background-color: #666;
  }
  /deep/ .mint-tab-container-wrap{
    height: 100%;
    // padding-bottom: 10vh;
    background-color: #fff;
  }
  /deep/ .mint-tab-container-item{
    // padding-bottom: 5vh;
    height: 100%;
    overflow: hidden;

    overflow-y: auto;
    padding-bottom: 180px;
    background-color: #fff;
    p{
      padding: 0 30px;
      font-size: 27px;
      line-height: 48px;
      text-indent: 2em;
    }
    .descimg{
      height: 3000px;
      margin-bottom: 480px;
      width: 100vw;
      background-image: url('~assets/testImg/desc.jpg');
      background-size: 100%;
      background-repeat: no-repeat;

    }
    ul{
      width: 100%;
      height: 100vw;
      overflow: hidden;
      overflow-y: auto;
      padding-bottom: 380px;
      background-color: #fff;
      // padding-bottom: 200px;
      li{
        overflow: hidden;
        display: flex;
        justify-content: space-between;
        padding: 0 30px;
        width: 100%;
        height: 105px;
        line-height: 105px;
        font-size: 27px;
        color: #444444;
        background: #fff;
        border-bottom: 1px solid #eee;
        span{
          display: inline-block;
          overflow: hidden;
          margin-top: 1px;
          white-space: nowrap;
          text-overflow: ellipsis;

        }
        .rightArr{
          width: 80px;
          text-align: right;
          font-size: 30px;
          color: #999999;
        }
        
      }
    }
  }
  /deep/ .mint-cell{
    height: 100px;
    .mint-cell-wrapper{
      padding: 0 30px;
      height: 105px;
      // line-height: 100px;
      font-size: 27px;
      color: #444444;
      .mint-cell-allow-right{
        margin-right: 10px;
      }
      .mint-cell-allow-right:after {
        
        border: .267vw solid #c8c8cd;
        border-bottom-width: 0;
        border-left-width: 0;
        content: " ";
        top: 50%;
        right: 40px;
        position: absolute;
        width: 1.667vw;
        height: 1.667vw;
        font-weight: 700;
        color: #999;
        -webkit-transform: translateY(-50%) rotate(45deg);
        transform: translateY(-50%) rotate(45deg);
      }
    }
  }
  .toast-wrap{
    position: fixed;
    left: 0;
    top: 0;
    z-index: 99999999999;
    width: 100%;
    height: 100%;
    background-color: rgba(22, 22, 22, 0.2);
    .toast{
      position: absolute;
      left: 0;
      top: 40%;
      width: 100vw;
      height: 160px;
      background-color: rgba($color: #000000, $alpha: 0.7);
      font-size: 35px;
      line-height: 160px;
      text-align: center;
      letter-spacing: 3px;
      color: #fff;
    }
  }
}
    

</style>







// WEBPACK FOOTER //
// src/pages/home/home.vue